import { render, staticRenderFns } from "./AnnouncementsCard.vue?vue&type=template&id=0d5b89cb&scoped=true&"
import script from "./AnnouncementsCard.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsCard.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementsCard.vue?vue&type=style&index=0&id=0d5b89cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5b89cb",
  null
  
)

export default component.exports